import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Badge } from 'antd';

import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function HighChargebackRate() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);

  const highChargebackRateNotifications = (notifications || []).find(
    n => n.type === ENotificationType.HIGH_CHARGEBACK_RATE
  );
  if (!highChargebackRateNotifications?.quantity) return null;

  return (
    <Link to={`/producer/notifications/${ENotificationType.HIGH_CHARGEBACK_RATE}`}>
      <div className='flex items-center justify-between px-4 py-2.5 transition-colors hover:bg-[#f5f5f5]'>
        <span className='text-sm font-medium text-[#37474f]'>Alto índice de chargeback</span>
        <Badge count={highChargebackRateNotifications?.quantity || 0} showZero />
      </div>
    </Link>
  );
}
